var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image"},[_c('img',{staticClass:"image-img",attrs:{"src":_vm.baseUrl}}),_c('figcaption',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }